<template>
  <div class="mt-2 flex w-full flex-col">
    <div v-if="!!logs['unread'].length" class="divide-y">
      <div
        class="mt-2 flex justify-center overflow-visible border-t border-red-400"
      >
        <span class="-mt-2.5 bg-white px-2 text-xs text-red-400 uppercase">
          {{ $t("DEALS.DEAL_NOTES.UNREAD") }}
        </span>
      </div>
      <note-item
        v-for="note in logs['unread']"
        :id="note.id"
        :key="note.id"
        :item="note"
        :editing-note="noteToEdit?.id === note.id"
        class="transition-colors duration-500 ease-in-out"
        @note:edit="emit('edit-note:set', note)"
        @note:deleted="emit('note:deleted')"
        @note:pin-changed="emit('note:pin-changed')"
      />
    </div>
    <div v-if="!!logs['read'].length" class="divide-y">
      <div
        v-if="!!logs['unread'].length"
        class="mt-2 flex justify-center overflow-visible border-t"
      >
        <span class="-mt-2.5 bg-white px-2 text-xs uppercase">
          {{ $t("DEALS.DEAL_NOTES.EARLIER") }}
        </span>
      </div>
      <note-item
        v-for="note in logs['read']"
        :id="note.id"
        :key="note.id"
        :item="note"
        :editing-note="noteToEdit?.id === note.id"
        class="transition-colors duration-500 ease-in-out"
        @note:edit="emit('edit-note:set', note)"
        @note:deleted="emit('note:deleted')"
        @note:pin-changed="emit('note:pin-changed')"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import NoteItem from "@/components/deals/dealActivity/notes/NoteItem.vue";

import type { NoteLogData } from "@/models/communicationLogs";
import type { Note } from "@/models/notes";

const { logs, noteToEdit } = defineProps<{
  logs: {
    read: NoteLogData[];
    unread: NoteLogData[];
  };
  noteToEdit?: Note | null;
}>();

const emit = defineEmits<{
  "edit-note:set": [note: Note | null];
  "note:deleted": [];
  "note:pin-changed": [];
}>();
</script>
<style scoped>
@reference "@/assets/tailwind.css";

.content-height {
  height: 97%;
}
</style>
